import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, typeof as _typeof, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { omit, EMPTY_OBJECT } from '../../utils/object.esm.js';
import Flex from '../_primitives/flex/flex.esm.js';
import Icon from '../_primitives/icon/icon.esm.js';
import svgIcons from '../_primitives/icon/svg-icons.esm.js';
import ToggleFlipIcon from '../_primitives/icon/toggle-flip-icon.esm.js';
import { isIconProps } from '../_primitives/icon/types.esm.js';

var _excluded = ["buttonLabel", "icon", "iconSize", "isLoading"];
function shouldRenderButtonIcon(icon) {
  return typeof icon === 'string' && icon in svgIcons || isIconProps(icon);
}
function shouldFlipIcon(icon) {
  return _typeof(icon) === 'object' &&
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon.hasOwnProperty('shouldFlipIcon') &&
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon['shouldFlipIcon'];
}
function ButtonIcon(props) {
  var buttonLabel = props.buttonLabel,
    icon = props.icon,
    iconSize = props.iconSize,
    isLoading = props.isLoading,
    rest = _objectWithoutProperties(props, _excluded);
  var iconProps = useMemo(function () {
    return _objectSpread2({
      icon: isIconProps(icon) ? icon.icon : icon,
      size: isIconProps(icon) ? icon.size || iconSize : iconSize,
      sx: _objectSpread2({
        '&.is-hidden': {
          opacity: 0
        }
      }, isIconProps(icon) ? icon.sx : EMPTY_OBJECT)
    }, isIconProps(icon) ? _objectSpread2(_objectSpread2({}, omit(icon, ['icon', 'size', 'sx'])), rest) : rest);
  }, [icon, iconSize, rest]);
  var Component = shouldFlipIcon(icon) ? ToggleFlipIcon : Icon;
  return /*#__PURE__*/React.createElement(Component, _extends({
    as: Flex,
    className: classNames({
      'is-hidden': isLoading
    }),
    a11yHidden: true,
    a11yLabel: buttonLabel
  }, iconProps));
}

export default ButtonIcon;
export { shouldRenderButtonIcon };
//# sourceMappingURL=button-icon.esm.js.map
